module.exports = __webpack_public_path__ + "static/media/ExoBNNVARA-Bold.d9791d9e.woff";